// =======================
// src/componentes/DocumentStatus.jsx
// =======================
import React from 'react';
import { styled } from '@mui/material/styles';
import { ajustarTamanhoFonteEscola } from "../estilos/global";

// Badge estilizado
const StatusBadge = styled('span')(({ status, theme }) => ({
  padding: '4px 8px',
  borderRadius: '12px',
  fontSize: ajustarTamanhoFonteEscola('0.75rem'),
  fontWeight: 'bold',
  backgroundColor: 
    status === 'aprovado' ? theme.palette.success.light :
    status === 'correcao' ? theme.palette.error.light :
    theme.palette.warning.light,
  color: 
    status === 'aprovado' ? theme.palette.success.contrastText :
    status === 'correcao' ? theme.palette.error.contrastText :
    theme.palette.warning.contrastText,
  transition: 'all 0.3s ease'
}));

const DocumentStatus = ({ aprovacao, alteracao_ativa }) => {
  let label = 'Em análise';
  let status = 'analise';

  if (aprovacao === true && alteracao_ativa === false) {
    label = 'Aprovado';
    status = 'aprovado';
  } else if (aprovacao === false && alteracao_ativa === true) {
    label = 'Correção pendente';
    status = 'correcao';
  } else if (aprovacao === false && alteracao_ativa === false) {
    label = 'Em análise';
    status = 'analise';
  }

  return <StatusBadge status={status}>{label}</StatusBadge>;
};

export default DocumentStatus;
